// A tiny event-based subscription gate to request subscription from anywhere

const SUBSCRIPTION_REQUIRED_EVENT = 'SUBSCRIPTION_REQUIRED';

let pendingActionRef = null;

export function requestSubscription(pendingAction, entryPoint) {
  // pendingAction: optional function to be executed after successful subscription
  // entryPoint: optional entry point for tracking
  pendingActionRef = typeof pendingAction === 'function' ? pendingAction : null;
  
  if (typeof window !== 'undefined') {
    const event = new CustomEvent(SUBSCRIPTION_REQUIRED_EVENT, {
      detail: {
        pendingAction: pendingActionRef,
        entry_point: entryPoint
      }
    });
    
    window.dispatchEvent(event);
  }
}

export function consumePendingAction() {
  const fn = pendingActionRef;
  pendingActionRef = null;
  return fn;
}

export const SUBSCRIPTION_GATE_EVENTS = {
  SUBSCRIPTION_REQUIRED_EVENT,
};
